export default {
  hasProgressedToStage(stage, currentStatus) {
      switch(stage) {
          case 'Order Submitted':
              if (
                  currentStatus === 'Supplier Added' ||
                  currentStatus === 'Suppliers Added' ||
                  currentStatus === 'Preferred Supplier Selected' ||
                  currentStatus === 'Order Placed' ||
                  currentStatus === 'Order Accepted' ||
                  currentStatus === 'Stock' ||
                  currentStatus === 'Delivery Offered' ||
                  currentStatus === 'Delivery Arranged' ||
                  currentStatus === 'Contract Implemented' ||
                  currentStatus === 'Implemented'
              ) {
                  return true;
              }
              break;
          case 'Order Confirmed':
              if (
                  currentStatus === 'Order Placed' ||
                  currentStatus === 'Order Accepted' ||
                  currentStatus === 'Stock' ||
                  currentStatus === 'Delivery Offered' ||
                  currentStatus === 'Delivery Arranged' ||
                  currentStatus === 'Contract Implemented' ||
                  currentStatus === 'Implemented'
              ) {
                  return true;
              }
              break;
          case 'Vehicle has arrived in stock':
              if (
                  currentStatus === 'Delivery Offered' ||
                  currentStatus === 'Delivery Arranged' ||
                  currentStatus === 'Contract Implemented' ||
                  currentStatus === 'Implemented'
              ) {
                  return true;
              }
              break;
          case 'Delivery Organised':
          case 'Delivery Arranged':
              if (
                  currentStatus === 'Delivery Arranged' ||
                  currentStatus === 'Contract Implemented' ||
                  currentStatus === 'Implemented'
              ) {
                  return true;
              }
              break;
          case 'Delivered':
              if (
                  currentStatus === 'Implemented'
              ) {
                  return true;
              }
              break;
          default:
              return false;

      }

      return false;
  }
}
